export const EmptyDateFillDefaultRuleV2 = async (item, onValueChanged) => {
    if (item.field.FieldType === 'alt-date' && item.data.valueToEdit === '')
        onValueChanged(null, 0, item.field.id);
};
